// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"dae9d826","278":"1aa885e0","579":"e18f8059"}[chunkId] + ".css";
};